import { FC, Fragment, useMemo, useState } from "react";
import { LiveButton, SpeedoMeter } from "../../../CommonComponents/timeline/Timeline";
import OmniSelect from "../../../CommonComponents/omni-select/OmniSelect";
import { TimeFrameOptions } from "../../../CommonComponents/timeline/constant";
import { TimeIcon, TimeIntervalSvg } from "../../../CommonComponents/svgs/Svgs";
import { getFormatedTime } from "../../../../utils/commonFunctions";
import useViewer from "../../hooks/useViewer";
import CustomToolTip from "../../../CommonComponents/CustomToolTip";
import Controller from "./Controller";
import useUrlParams from "../../hooks/useUrlParams";
import useScenario from "../../hooks/useScenario";
import useTimeframe from "../../hooks/useTimeframe";
import { isOperateMode } from "../../hooks/utils";

interface ContactHeaderProps {
  Orbits: string[],
  selectedOrbit: string,
  onOrbitChange: (orbit: string) => void
  selectedFrame: string
  onTimeFrameChange: (frame: string) => void
}

const ContactTimelineHeader: FC<ContactHeaderProps> = ({
  Orbits,
  selectedFrame,
  onTimeFrameChange,
}) => {
  const { dashboard } = useUrlParams()
  const { multiplier, go_live } = useViewer()
  const { scenario } = useScenario();
  const { simulation_start_time, simulation_duration, current_time } = useTimeframe();

  const [openSelect, setOpenSelect] = useState<null | string>(null)
  const operateMode = isOperateMode(dashboard, scenario)

  const time = useMemo(() => operateMode ? current_time : simulation_start_time, [operateMode, current_time, simulation_start_time])

  return (
    <div className='hud__timeline__header'>
      <div className='hud__timeline__header__left__container'>
        <span className='hud__timeline__header__label'>ONBOARD & GROUND SCHEDULE</span>
        <div className='hud__timeline__header__timeDetails__container'>
          <div className='hud__timeline__header__time__label'>
            <CustomToolTip title={operateMode ? 'Current UTC Time' : 'Simulation Start Time'}>
              {operateMode ? 'Current UTC' : 'Start'}
            </CustomToolTip>
          </div>
          <div className='hud__timeline__header__time__details'>{getFormatedTime(time)}</div>
          {!operateMode &&
            <Fragment>
              <div className='details__devider' />
              <div className='hud__timeline__header__time__label'>
                <CustomToolTip title='Simulation Duration'>
                  <TimeIcon />
                </CustomToolTip>
              </div>
              <div className='hud__timeline__header__time__details'>{simulation_duration} min</div>
            </Fragment>
          }
        </div>
      </div>
      <Controller />
      <div className='hud__timeline__header__right__container'>
        <LiveButton onClick={go_live} />
        {dashboard !== 'operate' && <SpeedoMeter value={multiplier} />}
        <div className='hud__timeframe__details__container'>
          <div className='timeframe__label'>
            <CustomToolTip title='Timeframe'>
              <TimeIntervalSvg />
            </CustomToolTip>
          </div>
          <div className='hud__omni__select__container'>
            <OmniSelect
              id='omni__select__timeframe'
              open={openSelect}
              setOpen={setOpenSelect}
              disabled={false}
              className='updated__omni__select__border'
              options={TimeFrameOptions}
              value={selectedFrame}
              onChange={onTimeFrameChange}
              headerOption={{
                title: 'Timeframe',
                icon: <TimeIntervalSvg />
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactTimelineHeader